export default __webpack_public_path__ + "static/thumbnailOnlineSelling-bdfffd6db4571f7aea91a807570e2072.jpg";